import { render, staticRenderFns } from "./selectRatio.vue?vue&type=template&id=1bdeac30&scoped=true"
import script from "./selectRatio.vue?vue&type=script&lang=js"
export * from "./selectRatio.vue?vue&type=script&lang=js"
import style0 from "./selectRatio.vue?vue&type=style&index=0&id=1bdeac30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdeac30",
  null
  
)

export default component.exports